import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { TextField } from 'edenred-ui';

import { FormFields, createRules } from '@epi-forms/helpers';
import { maxLength } from '@epi-helpers/formHelpers/validators';

export function AdditionalMessageField() {
  const name = FormFields.AdditionalMessage;
  const { control } = useFormContext();
  const validators = [maxLength(500)];
  const rules = createRules(validators);

  const {
    field: { ref, value, onChange: setValue },
    fieldState: { error }
  } = useController({
    name,
    control,
    rules
  });

  return (
    <TextField
      value={value}
      id={name}
      error={!!error}
      helperText={error?.message}
      inputRef={ref}
      onChange={setValue}
    />
  );
}
